export enum ModalTypes {
  PRELOADER = "PRELOADER",
  PROGRESS = "PROGRESS",
  DELETE = "DELETE",
  FORM = "FORM",
  SHARE_PROJECT = "SHARE_PROJECT",
  EDIT_POLYGON = "EDIT_POLYGON",
  SUCCESS = "SUCCESS",
  PROVIDER_MANAGER_MODAL = "PROVIDER_MANAGER_MODAL",
  PROVIDER_FILE_MANAGER_MODAL = "PROVIDER_FILE_MANAGER_MODAL",
  PROVIDER_FOLDERS_FILES_MANAGER_MODAL = "PROVIDER_FOLDERS_FILES_MANAGER_MODAL",
  CLASSIFICATION_POINT_MODAL = "CLASSIFICATION_POINT_MODAL"
}
